var careerPageJS = (function() {
  return {
    init: init
  };

  function init() {
    //getParents init
    getParentsElem();

    // Trigger Filter position department wise
    departmentWiseFiter();

    //Show positions details
    positionListLink();

    //Apply job
    applyJob();

    //btn Open Positions for hero unit
    btnOpenPositions();

    //Gallary
    gallaryFunc();

    uiBindings();
  }

  function uiBindings() {
    var departmentURI = decodeURIComponent(location.hash.substring(1)),
      department = departmentURI.replace(/[^a-z\d\-]+/gi, ""), //Only support a-z, digits and hyphen.
      has_valid_hash = department
        ? document.querySelector("[data-filter-trigger=" + department + "]")
        : false;

    if (has_valid_hash) {
      has_valid_hash.click();
    } else {
      // Else Make department active, which has position (Only first department)
      var pos = document.querySelector(".has-positions"),
        departmentTrigger = pos ? pos.dataset.filterTarget : false;
      if (departmentTrigger) {
        document
          .querySelector("[data-filter-trigger=" + departmentTrigger + "]")
          .click();
      }
    }
  }

  function gallaryFunc() {
    var ele,
      i,
      autoSlide = true,
      modGallery = document.querySelectorAll(".mod-gallery"),
      pagingIsArrow = document.querySelectorAll(".paging.is-arrow"),
      pagingBullet = document.querySelectorAll(".mod-gallery .paging-link");

    for (i = 0; i < modGallery.length; i++) {
      ele = modGallery[i];

      //AutoSLide control
      ele.addEventListener(
        "mouseover",
        function(e) {
          autoSlide = false;
        },
        false
      );

      ele.addEventListener(
        "mouseout",
        function(e) {
          autoSlide = true;
        },
        false
      );

      //Keyboard Events
      ele.addEventListener(
        "keydown",
        function(e) {
          var keycode = e.keyCode || e.which,
            that = this;
          switch (keycode) {
            case 9:
              var isArrowNode = that.querySelectorAll(".paging.is-arrow");
              for (var index = 0; index < isArrowNode.length; index++) {
                var element = isArrowNode[index];
                if (document.activeElement == element) {
                  that
                    .querySelectorAll(".gallery-placeholder .gal-img")[0]
                    .focus();
                }
              }
              break;
            case 37:
              that.querySelector(".paging.is-arrow.is-left").click();
              that.querySelector(".paging.is-arrow.is-left").focus();
              break;
            case 39:
              that.querySelector(".paging.is-arrow.is-right").click();
              that.querySelector(".paging.is-arrow.is-right").focus();
              break;
          }
        },
        false
      );
    }

    //Left and right Arrow
    for (i = 0; i < pagingIsArrow.length; i++) {
      ele = pagingIsArrow[i];
      ele.addEventListener(
        "click",
        function(e) {
          e.preventDefault();
          var dir = 0,
            that = this,
            currentActiveIndex = 0,
            newActiveIndex = 0,
            parentGallaryNode = that.getParents(".mod-gallery")[0],
            parentId = parentGallaryNode.getAttribute("id"),
            pagingNodes = parentGallaryNode.querySelectorAll(".paging-link"),
            pagingLength = pagingNodes.length,
            activeNode = parentGallaryNode.querySelector(
              ".paging-link.is-active"
            );

          //Get Current Index
          for (var index = 0; index < pagingNodes.length; index++) {
            if (pagingNodes[index] == activeNode) {
              currentActiveIndex = index;
              break;
            }
          }

          if (that.classList.contains("is-left")) {
            dir = -1;
          }

          if (that.classList.contains("is-right")) {
            dir = 1;
          }

          newActiveIndex = currentActiveIndex + dir;

          if (newActiveIndex < 0) {
            newActiveIndex = pagingLength - 1;
          } else if (newActiveIndex >= pagingLength) {
            newActiveIndex = 0;
          }

          activeNode.classList.remove("is-active");
          pagingNodes[newActiveIndex].classList.add("is-active");
          parentGallaryNode
            .querySelector(".gallery-placeholder .gal-img.is-active")
            .classList.remove("is-active");
          parentGallaryNode
            .querySelectorAll(".gallery-placeholder .gal-img")
            [newActiveIndex].classList.add("is-active");

          if (parentId == "employeeFeedback") {
            parentGallaryNode
              .querySelector(".quote-msg.is-active")
              .classList.remove("is-active");
            parentGallaryNode
              .querySelectorAll(".quote-msg")
              [newActiveIndex].classList.add("is-active");
            parentGallaryNode
              .querySelector("cite .title.is-active")
              .classList.remove("is-active");
            parentGallaryNode
              .querySelectorAll("cite .title")
              [newActiveIndex].classList.add("is-active");
          }
        },
        false
      );
    }

    //Bullet Pagination
    for (i = 0; i < pagingBullet.length; i++) {
      ele = pagingBullet[i];
      ele.addEventListener(
        "click",
        function(e) {
          e.preventDefault();

          var that = this;

          if (that.classList.contains("is-active")) {
            return;
          }

          var pagingIndex = 0,
            parentGallaryNode = that.getParents(".mod-gallery")[0],
            parentId = parentGallaryNode.getAttribute("id"),
            pagingNodes = parentGallaryNode.querySelectorAll(".paging-link"),
            pagingLength = pagingNodes.length,
            activeNode = parentGallaryNode.querySelector(
              ".paging-link.is-active"
            );

          //Get Current Index
          for (var index = 0; index < pagingNodes.length; index++) {
            if (pagingNodes[index] == that) {
              pagingIndex = index;
              break;
            }
          }

          activeNode.classList.remove("is-active");
          pagingNodes[pagingIndex].classList.add("is-active");
          parentGallaryNode
            .querySelector(".gallery-placeholder .gal-img.is-active")
            .classList.remove("is-active");
          parentGallaryNode
            .querySelectorAll(".gallery-placeholder .gal-img")
            [pagingIndex].classList.add("is-active");

          if (parentId == "employeeFeedback" && pagingIndex < pagingLength) {
            parentGallaryNode
              .querySelector(".quote-msg.is-active")
              .classList.remove("is-active");
            parentGallaryNode
              .querySelectorAll(".quote-msg")
              [pagingIndex].classList.add("is-active");
            parentGallaryNode
              .querySelector("cite .title.is-active")
              .classList.remove("is-active");
            parentGallaryNode
              .querySelectorAll("cite .title")
              [pagingIndex].classList.add("is-active");
          }
        },
        false
      );
    }

    //Auto Slide Every 10 second
    setInterval(function() {
      if (autoSlide) {
        var pagingRightArrow = document.querySelectorAll(
          ".paging.is-arrow.is-right"
        );
        for (var index = 0; index < pagingRightArrow.length; index++) {
          pagingRightArrow[index].click();
        }
      }
    }, 10000);
  }

  function btnOpenPositions() {
    var ele,
      i,
      btnOpenPositions = document.querySelectorAll(".btnOpenPositions");
    for (i = 0; i < btnOpenPositions.length; i++) {
      ele = btnOpenPositions[i];

      ele.addEventListener(
        "click",
        function(e) {
          e.preventDefault();
          bsLib.scrollIt(
            document.getElementById("sectionPositions").offsetTop - 70,
            1000
          );
        },
        false
      );
    }
  }

  function applyJob() {
    var ele,
      i,
      jobElem = document.querySelectorAll(".job-apply");
    for (i = 0; i < jobElem.length; i++) {
      ele = jobElem[i];
      ele.addEventListener(
        "click",
        function(e) {
          e.preventDefault();
          var that = this,
            subject = "Job Application: " + that.dataset.subject,
            workable_id = that.dataset.workableId;

          //Send event
          window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "OnCareersPositionApplied", {
              name: that.dataset.subject.trim(),
              workableId: workable_id
            })
          : "";

          workable_id
            ? window.open(workable_url + workable_id, "_blank")
            : (window.location.href =
                "mailto:careers@browserstack.com?subject=" + subject);
        },
        false
      );
    }
  }

  function positionListLink() {
    var ele,
      elem,
      i,
      j,
      listLinkWrapper,
      listLinkElem = document.querySelectorAll(
        ".jobs-list .list-item-wrapper .list-link"
      );
    for (i = 0; i < listLinkElem.length; i++) {
      ele = listLinkElem[i];

      ele.addEventListener(
        "click",
        function(e) {
          var that = this,
            hasButtonClass = e.target.className || e.srcElement.className;

          if (
            hasButtonClass.indexOf("btn") > -1 ||
            hasButtonClass.indexOf("desc") > -1 ||
            (e.target.tagName == "A" &&
              hasButtonClass.indexOf("list-link") == -1)
          ) {
            return;
          } else {
            if (
              that.classList.contains("list-link") &&
              that.parentElement.classList.contains("is-active")
            ) {
              that.parentElement.classList.remove("is-active");
            } else {
              if (e.target.classList.contains("list-item-wrapper")) {
                return;
              }

              listLinkWrapper = document.querySelectorAll(
                ".jobs-list .list-item-wrapper"
              );
              for (j = 0; j < listLinkWrapper.length; j++) {
                elem = listLinkWrapper[j];
                if (elem == that.parentElement) {
                  elem.classList.add("is-active");
                } else {
                  elem.classList.remove("is-active");
                }
              }

              //Send event
              window.hasOwnProperty("WebEventTracker")
              ? WebEventTracker.logEvent(EDS.webEvents, "OnCareersPositionSelected", {
                  name: that.dataset.subject.trim(),
                })
              : "";

              // Scroll to heading
              bsLib.scrollIt(that.offsetTop - 70, 250);
            }
          }
        },
        false
      );
    }
  }

  function departmentWiseFiter() {
    var ele,
      elem,
      i,
      j,
      filterTargetData,
      filterTriggerData,
      activeFilter,
      filterTrigger = document.querySelectorAll("[data-filter-trigger]"),
      filterClickCount = 0;
    for (i = 0; i < filterTrigger.length; i++) {
      ele = filterTrigger[i];

      ele.addEventListener(
        "click",
        function(e) {
          e.preventDefault();

          var that = this;
          activeFilter = document.querySelector(
            ".active-filter[data-filter-trigger]"
          );

          if (activeFilter) {
            //scroll to "pick-a-department" section
            bsLib.scrollIt(
              document.querySelector(".pick-a-department").offsetTop - 84, 
              300
            );
          }

          if (filterClickCount > 0) { //skip first click on pageload
            //Send event
            window.hasOwnProperty("WebEventTracker")
            ? WebEventTracker.logEvent(EDS.webEvents, "OnCareersDepartmentSelected", {
                name: that.innerHTML.trim(),
              })
            : "";
          }

          if (that.classList.contains("active-filter")) {
            return;
          }

          if (activeFilter) {
            activeFilter.classList.remove("active-filter");
          }

          that.classList.add("active-filter");

          filterTriggerData = that.dataset.filterTrigger;
          window.location.hash = "#" + filterTriggerData;

          filterTargetData = document.querySelectorAll("[data-filter-target]");
          for (j = 0; j < filterTargetData.length; j++) {
            elem = filterTargetData[j];
            if (elem.dataset.filterTarget == filterTriggerData) {
              elem.classList.remove("hide");

              var position = elem.querySelectorAll(
                ".jobs-list > .list-item-wrapper"
              );
              if (position.length == 1) {
                position[0].classList.add("is-active");
              }
            } else {
              elem.classList.add("hide");
            }
          }

          filterClickCount++;
        },
        false
      );
    }
  }

  function getParentsElem() {
    //Matches Polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }
    /*
     * Get Parents element of selector node
     * return Array
     */
    Element.prototype.getParents = function(selector) {
      var elements = [];
      var elem = this;
      var ishaveselector = selector !== undefined;

      while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
          continue;
        }

        if (!ishaveselector || elem.matches(selector)) {
          elements.push(elem);
        }
      }

      return elements;
    };
  }
})();

careerPageJS.init();
